import { Observable } from 'rxjs/internal/Observable';

export class ExpiringCache {
    expiresAt: number;
    district: any;
    itemCache: Observable<any>;
}
